import { useMemo,useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MultiTable from "../../../Common/MUITable";
import {
  calculateDeploymentPercent,
} from "./reportCommon";
import RcDeploymentFilter from "./RcDeploymentFilter";
import DelhiReportExport from "./DelhiReportExport";
import { RcDeployeVehicleSummary , GetAllCircles ,getTodayDate, } from "./ReportApi";

const formatTons = (value) => {
  if (value === null || value === undefined || value === "") return "";
  if (Number(value) === 0) return "0";
  return `${value}T`;
};

const buildDeploymentRow = (row) => ({
  ...row,
  totalTonsDisplay: formatTons(row.totalTons),
  deploymentPercent:
    row.deploymentPercentage ??
    calculateDeploymentPercent(
      row.planedVehicles,
      row.inputMobileApp
    ),
});

const buildTotalRow = (rows) => {
  const totals = rows.reduce(
    (acc, row) => ({
      plannedVehicles: acc.plannedVehicles + row.plannedVehicles,
      inputMobileApp: acc.inputMobileApp + row.inputMobileApp,
      tripsToW2EAndDumpsite:
        acc.tripsToW2EAndDumpsite + row.tripsToW2EAndDumpsite,
      totalTons: acc.totalTons + (Number(row.totalTons) || 0),
    }),
    {
      plannedVehicles: 0,
      inputMobileApp: 0,
      tripsToW2EAndDumpsite: 0,
      totalTons: 0,
    }
  );


  return {
    wardName: "Total",
    isTotalRow: true,
    plannedVehicles: totals.plannedVehicles,
    inputMobileApp: totals.inputMobileApp,
    tripsToW2EAndDumpsite: totals.tripsToW2EAndDumpsite,
    wasteTypeName: "",
    siteName: "",
    totalTons: totals.totalTons,
    totalTonsDisplay: formatTons(totals.totalTons),
    deploymentPercent: calculateDeploymentPercent(
      totals.plannedVehicles,
      totals.inputMobileApp
    ),
  };
};

const totalCellStyle = { fontWeight: 700 };

const renderTotalAwareCell = (field) => (row) =>
  row.isTotalRow ? (
    <span style={totalCellStyle}>{row[field]}</span>
  ) : (
    row[field]
  );

const exportColumns = [
  { label: "Ward", field: "wardName" },
  { label: "Planned Vehicles", field: "plannedVehicles" },
  { label: "Input Mobile App", field: "inputMobileApp" },
  { label: "Trips to W2E & Dumpsite", field: "tripsToW2EAndDumpsite" },
  { label: "Total Tons", field: "totalTonsDisplay" },
  { label: "% of Deployment", field: "deploymentPercent" },
];

const DEFAULT_FILTERS = {
  circleId: "",
  fromDate: getTodayDate(),
  toDate: getTodayDate(),
};

const RcDeploymentReport = () => {
  const navigate = useNavigate();
const [filters, setFilters] = useState(DEFAULT_FILTERS);

const [appliedFilters, setAppliedFilters] = useState(DEFAULT_FILTERS);
const [reportData, setReportData] = useState([]);
const [loading, setLoading] = useState(false);
const [error, setError] = useState("");
const [circleOptions, setCircleOptions] = useState([]);

useEffect(() => {
  const fetchCircles = async () => {
    try {
      const response = await GetAllCircles();

      console.log("FULL CIRCLE RESPONSE:", response);
      console.log("CIRCLE RESPONSE DATA:", response?.data);

      const circles =
        response?.data?.data ||
        response?.data ||
        [];

      console.log("CIRCLES USED BY DROPDOWN:", circles);

      setCircleOptions(circles);
    } catch (error) {
      console.error("Error fetching circles:", error);
      setCircleOptions([]);
    }
  };

  fetchCircles();
}, []);

useEffect(() => {
  const fetchDeploymentReport = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await RcDeployeVehicleSummary({
        circleId: appliedFilters.circleId,
        fromDate: appliedFilters.fromDate,
        toDate: appliedFilters.toDate,
      });

      const data = response?.data?.data || [];

      setReportData(data);
    } catch (err) {
      console.error("Error fetching RC deployment report:", err);

      setError(
        err?.response?.data?.message ||
          "Failed to fetch RC deployment report."
      );

      setReportData([]);
    } finally {
      setLoading(false);
    }
  };

  fetchDeploymentReport();
}, [appliedFilters]);

const filteredRows = useMemo(() => {
  const rows = reportData.map((row) => ({
    circleId: row.circleId,

    wardName: row.circleName,

    plannedVehicles: Number(row.planedVehicles) || 0,

    inputMobileApp: Number(row.inputMobileApp) || 0,

    tripsToW2EAndDumpsite:
      Number(row.tripsToW2EAndDumpsite) || 0,

    wasteTypeName: "",

    siteName: "",

    totalTons: Number(row.totalTons) || 0,

    totalTonsDisplay: formatTons(row.totalTons),

    deploymentPercent:
      Number(row.deploymentPercentage) || 0,

    isTotalRow: false,
  }));

  if (rows.length === 0) {
    return [];
  }

  return [...rows, buildTotalRow(rows)];
}, [reportData]);

  const handleSearch = (values) => {
    setAppliedFilters(values);
  };

const handleReset = () => {
  const defaultFilters = {
    circleId: "",
    fromDate: getTodayDate(),
    toDate: getTodayDate(),
  };

  setFilters(defaultFilters);
  setAppliedFilters(defaultFilters);
};

const handleTripsClick = (row) => {
  if (row.isTotalRow) return;

  navigate("/rc-inner-report", {
    state: {
      parentRow: row,
      circleId: row.circleId,
      fromDate: appliedFilters.fromDate,
      toDate: appliedFilters.toDate,
    },
  });
};

  const tableColumns = [
    {
      label: "Ward",
      field: "wardName",
      width: "120px",
      render: renderTotalAwareCell("wardName"),
    },
    {
      label: "Planned Vehicles",
      field: "plannedVehicles",
      width: "140px",
      render: renderTotalAwareCell("plannedVehicles"),
    },
    {
      label: "Input Mobile App",
      field: "inputMobileApp",
      width: "140px",
      render: renderTotalAwareCell("inputMobileApp"),
    },
    {
      label: "Trips to W2E & Dumpsite",
      field: "tripsToW2EAndDumpsite",
      width: "180px",
      render: (row) =>
        row.isTotalRow ? (
          <span style={totalCellStyle}>{row.tripsToW2EAndDumpsite}</span>
        ) : (
          <span
            style={{
              cursor: "pointer",
              color: "#003366",
              textDecoration: "underline",
              fontWeight: 600,
            }}
            onClick={() => handleTripsClick(row)}
          >
            {row.tripsToW2EAndDumpsite}
          </span>
        ),
    },
    // {
    //   label: "Waste Type",
    //   field: "wasteTypeName",
    //   width: "120px",
    //   render: renderTotalAwareCell("wasteTypeName"),
    // },
    // {
    //   label: "Site Name",
    //   field: "siteName",
    //   width: "130px",
    //   render: renderTotalAwareCell("siteName"),
    // },
    {
      label: "Total Tons",
      field: "totalTonsDisplay",
      width: "120px",
      render: renderTotalAwareCell("totalTonsDisplay"),
    },
    {
      label: "% of Deployment",
      field: "deploymentPercent",
      width: "140px",
      render: renderTotalAwareCell("deploymentPercent"),
    },
  ];

  return (
    <div className="content text-start">
      <div className="page-content">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3 mt-3 mb-3">
          <div className="me-md-3">
            <h5 className="mb-1 fw-semibold">RC Deployment Report</h5>
           
          </div>
          <DelhiReportExport
            reportData={filteredRows}
            reportTitle="RC Deployment"
            columns={exportColumns}
            fileName="RcDeploymentReport"
          />
        </div>

        <div className="card shadow mb-3">
          <div className="card-body">
            <RcDeploymentFilter
              initialValues={filters}
                circleOptions={circleOptions}
              onSearch={(values) => {
                setFilters(values);
                handleSearch(values);
              }}
              onReset={handleReset}
            />
          </div>
        </div>

        <div className="card shadow">
          <div className="card-body">
            <div className="table-responsive">
              <MultiTable
                needSRNumber
                columns={tableColumns}
                rows={filteredRows}
                tableHeight={500}
                hasTotalRow
                rowsPerPageOptions={[10, 25, 50, 100]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RcDeploymentReport;
